import React from "react";

import { getStatisticHeader } from "src/helpers/statistic-list-item";
import Pictogram, {
  PictogramVariants,
} from "../../../../../components/Pictogram/Pictogram";

import "./SentimentAnalysisBox.scss";

export function SentimentAnalysisBox(props) {
  const { data } = props;

  const provider = data.key.split(`-`)[0];

  const getIconName = () => {
    switch (provider) {
      case "sentimentPositiveShare":
        return "positive";
      case "sentimentNeutralShare":
        return "neutral";
      case "sentimentNegativeShare":
        return "negative";
      case "sentimentProductRelatedShare":
        return "productMentions";

      default:
        return "neutral";
    }
  };

  const getIconVariant = () => {
    switch (provider) {
      case "sentimentPositiveShare":
        return PictogramVariants.ForestCrayola;
      case "sentimentNeutralShare":
        return PictogramVariants.PhilippineSilver;
      case "sentimentNegativeShare":
        return PictogramVariants.Vermilion;
      case "sentimentProductRelatedShare":
        return PictogramVariants.Instagram;

      default:
        return PictogramVariants.PhilippineSilver;
    }
  };

  return (
    <div className="sentiment-analysis-box">
      <span className="sentiment-analysis-box__name">
        {getStatisticHeader(provider)}
      </span>

      <span className="sentiment-analysis-box__value">
        <span className="sentiment-analysis-box__value-icon">
          <Pictogram
            identifier={`Sentiment/${getIconName()}`}
            variant={getIconVariant()}
          />
        </span>
        {data?.value || 0}%
      </span>
    </div>
  );
}
